/* Keep AiTrillion's chat launcher usable without its automatic tablet greeting. */
(() => {
  const tablet = matchMedia('(min-width: 750px) and (max-width: 989px)');
  const style = document.createElement('style');
  style.textContent = '@media(min-width:750px) and (max-width:989px){#aiWhatsapppChat:not(.aio-open-frame){height:50px!important;width:54px!important}}';
  document.head.append(style);
  let frame;
  function sync() {
    const next = document.getElementById('aiWhatsapppChat');
    if (!next) return;
    if (next !== frame) { frame = next; frame.addEventListener('load', sync); }
    try {
      const doc = frame.contentDocument;
      if (!doc?.head) return;
      let localStyle = doc.getElementById('yieon-tablet-greeting-style');
      if (!localStyle) {
        localStyle = doc.createElement('style');
        localStyle.id = 'yieon-tablet-greeting-style';
        doc.head.append(localStyle);
      }
      const value = tablet.matches ? '#is_greeting_display{display:none!important}' : '';
      if (localStyle.textContent !== value) localStyle.textContent = value;
    } catch { /* Cross-origin app updates remain under the app's own control. */ }
  }
  new MutationObserver(sync).observe(document.body, {childList:true});
  tablet.addEventListener('change', sync);
  sync();
})();
